import { render } from "./CategoryDetail.vue?vue&type=template&id=08ecab49&scoped=true"
import script from "./CategoryDetail.vue?vue&type=script&lang=js"
export * from "./CategoryDetail.vue?vue&type=script&lang=js"

import "./CategoryDetail.vue?vue&type=style&index=0&id=08ecab49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ecab49"]])

export default __exports__